<template>
  <div class="page-wrapper light">  
    <!--<InsuBannerInfo
     :type="currentType"
    />-->
    <InsuBanner 
      :banner="currentType"
      :loading="loading"
    >
      <component 
        slot="form"
        v-bind="{handleQuery}"
        :is="categories[currentType].component"
        :model="queryModel"
        :type="currentType"
        :carno="currentCarno"
      />
    </InsuBanner>    
    <InsuDescrption :type="currentType" />    
    <component
      :is="categories[currentType].prodComponent"
      v-bind="{
        loading,
        products,
        triggerScrollToProd,
        triggerModal,
        hasSelected,
        handlePurchase,
        prodsCount,
        tips
      }"
    />
    <InsuProdDetailsModal
      v-model="modal"
      v-bind="{handlePurchase}"
      :details="modalDetails"
    />
     <Footerbar v-if="currentType=='pet'" />
  </div>
</template>

<script>
  import { mapState, mapActions, mapMutations } from 'vuex';
  //import { Poptip } from "iview";
  //import { Carousel, Slide } from 'vue-carousel'; 
  import InsuBanner from '@/components/banner/InsuBanner';
  import InsuBannerInfo from '@/components/banner/InsuBannerInfo';
  import InsuDescrption from '@/components/insurance/InsuDescrption';
  import InsuTravelQueryForm from '@/components/forms/InsuTravelQueryForm';
  import InsuVehicleQueryForm from '@/components/forms/InsuVehicleQueryForm';
  import InsuAccidentQueryForm from '@/components/forms/InsuAccidentQueryForm';
  import InsuPetQueryForm from '@/components/forms/InsuPetQueryForm';
  //import InsuVaccineQueryForm from '@/components/forms/InsuVaccineQueryForm';//20220414 Wen modify 富邦疫苗停售
  import InsuranceTravel from '@/pages/insurance/InsuranceTravel';
  import InsuranceVehicle from '@/pages/insurance/InsuranceVehicle';
  //import InsuranceAccident from '@/pages/insurance/InsuranceAccident';
  import InsurancePet from '@/pages/insurance/InsurancePet';
  //import InsuranceVaccine from '@/pages/insurance/InsuranceVaccine';//20220414 Wen modify 富邦疫苗停售
  import InsuProdDetailsModal from '@/components/modals/InsuProdDetailsModal'; 
  import Footerbar from '@/components/layout/Footerbar';   
  import {
    RESET_QUERY_MUTATION,
    RESET_PRODUCTS_MUTATION,
    RESET_SELECTED_MUTATION,
    INSU_MODAL_MUTATION,
    HANDLE_PAGE_SCROLL,
    HANDLE_PURCHASE_ACTION,
    FETCH_INSU_ACTION,
    FETCH_DETAILS_ACTION
  } from '@/store/modules/insurance/constants';  
  import { InsuranceMeta as metaInfo } from '@/utils/vue-meta';

  export default {
    components: { 
      InsuBanner,
      InsuBannerInfo,
      InsuDescrption,
      InsuProdDetailsModal,
      //Carousel,
      //Slide,
      Footerbar
       
    },
    metaInfo,   
      props: { //2021/11/17 Wen Add
        prods: {
        type: Array,
        default: () => []
      },
      value: { //2021/11/17 Wen Add
        type: Object,
        default: null
      },
      triggerScrollToProd: { //2021/11/17 Wen Add
        type: Function,
        default: () => {}
      }},
    data() {
      return {
        categories: {          
          car: {
            component: InsuVehicleQueryForm,
            prodComponent: InsuranceVehicle
          },
          motor: {
            component: InsuVehicleQueryForm,
            prodComponent: InsuranceVehicle
          },         
          pet: {
            component: InsuPetQueryForm,
            prodComponent: InsurancePet
          },
          /*vaccine: { //20220414 Wen modify 富邦疫苗停售
            component: InsuVaccineQueryForm,
            prodComponent: InsuranceVaccine
          },*/
          travel: {  //20210530  Wen modify 調整順序
            component: InsuTravelQueryForm,
            prodComponent: InsuranceTravel
          },
          /* accident: {  //20210830  Wen modify
            component: InsuAccidentQueryForm,
            prodComponent: InsuranceAccident
          },*/
        }
      };
    },
    computed: {
      ...mapState({
        loading: ({ insurance }) => insurance.loading,
        products: ({ insurance }) => insurance.products,
        modalDetails: ({ insurance }) => insurance.modal,
        hasSelected: ({ insurance }) => insurance.selectedInsus.length > 0,
        tips: ({ insurance }) => insurance.queryInfo.tips,
        queryModel({ insurance: { queryInfo } }) {
          const { currentType, currentCarno, $store } = this;
          const { initialQueryModel } = $store.getters;
          const { model } = queryInfo;
          return model || initialQueryModel[currentType];
        },
      }),
      modal: {
        get() { return this.$store.state.insurance.modal !== null; },
        set() { this.$store.commit(INSU_MODAL_MUTATION, null); }
      },
      prodsCount() {
        const { products } = this;
        if (!products) return null;
        return Object.keys(products).reduce((acc, key) => acc + products[key].length, 0);
      },
      currentType() {
        //console.log("type+++"+this.$route.params.type);
        return this.$route.params.type;
      },
       currentCarno() {
        //console.log('CarNo:'+this.$route.params.carno);
       // console.log('axios-CarNo:'+this.$route.query.e);

        return this.$route.params.carno;
      },    
      val: { //2021/11/17 Wen Add
        get() { return this.value; },
        set(val) { return this.$emit('input', val); }
      }
    },
    watch: { //2021/11/17 Wen Add
      prods(val) {
        if (!val) return;
        this.triggerScrollToProd();
      }
    },
    mounted() {
      const { scrollTo } = this.$route.params;
      if (scrollTo) return this.HANDLE_PAGE_SCROLL('.insu-desc');
       this.triggerScrollToProd();  //2021/11/17 Wen Add
    },
    beforeDestroy() {
      this.RESET_QUERY_MUTATION();
      this.RESET_PRODUCTS_MUTATION();
      this.RESET_SELECTED_MUTATION();
      this.INSU_MODAL_MUTATION(null);
    },
    methods: {
      ...mapMutations([
        RESET_QUERY_MUTATION,
        RESET_PRODUCTS_MUTATION,
        RESET_SELECTED_MUTATION,
        INSU_MODAL_MUTATION
      ]),
      ...mapActions([
        HANDLE_PAGE_SCROLL,
        FETCH_INSU_ACTION,
        FETCH_DETAILS_ACTION,
        HANDLE_PURCHASE_ACTION
      ]),
      triggerModal(prodsArr) {
        this.FETCH_DETAILS_ACTION(prodsArr);
      },
      triggerScrollToProd() {
        this.$nextTick(() => {
        this.HANDLE_PAGE_SCROLL('.insu-prod-wrapper');
        });
      },
      handleQuery(payload) {
        const { currentType, currentCarno } = this;
        this.FETCH_INSU_ACTION({ ...payload, type: currentType ,Carno: currentCarno });
      },
      handlePurchase(prodDetail) {
        const { currentType, queryModel } = this;
        this.INSU_MODAL_MUTATION(null);
        this.HANDLE_PURCHASE_ACTION({ prodDetail, queryModel, type: currentType });
      }
    }
  };
</script>
